import React, { useState } from 'react';
import { useNavigate } from "react-router-dom";
import ViewBooking from '../components/ViewBooking'

function Nav() {
  const [isOpen, setIsOpen] = useState(false);
  const [viewBookingToggle,setViewBookingToggle] = useState(false)
  const navigate = useNavigate();

  const viewBookingEvent = () => {
    setViewBookingToggle(!viewBookingToggle)
  }

  return (
    <nav className="bg-white border-gray-200 dark:bg-gray-900 z-999 relative">
      <div className="flex flex-wrap items-center justify-between mx-auto p-4">
        <span className="flex text-bold items-center space-x-3 rtl:space-x-reverse cursor-pointer" onClick={() => navigate("/")}>
          <img src="/logo1.png" className="h-8" alt="Logo" />
          <span className="self-center text-2xl font-semibold whitespace-nowrap dark:text-white">
            Driveline
          </span>
        </span>
        <button
          onClick={() => setIsOpen(!isOpen)}
          type="button"
          className="inline-flex items-center p-2 w-10 h-10 justify-center text-sm text-gray-500 rounded-lg md:hidden hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-gray-200 dark:text-gray-400 dark:hover:bg-gray-700 dark:focus:ring-gray-600"
          aria-controls="navbar-default"
          aria-expanded={isOpen}
        >
          <span className="sr-only">Open main menu</span>
          <svg
            className="w-5 h-5"
            aria-hidden="true"
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16m-7 6h7" />
          </svg>
        </button>
        <div className={`w-full md:flex md:w-auto ${isOpen ? "block" : "hidden"}`} id="navbar-default">
          <ul className="flex flex-col font-medium p-4 md:p-0 mt-4 border border-gray-100 rounded-lg bg-gray-50 md:flex-row md:space-x-8 md:mt-0 md:border-0 md:bg-white dark:bg-gray-800 md:dark:bg-gray-900 dark:border-gray-700">
            {/* <li>
              <span className="block py-2 px-3 text-gray-900 rounded md:bg-transparent md:text-gray-900 md:p-0 hover:text-primary cursor-pointer">
                Home
              </span>
            </li>
            <li>
              <span className="block py-2 px-3 text-gray-900 rounded md:bg-transparent md:text-gray-900 md:p-0 hover:text-primary cursor-pointer">
                <a href="mailto:drivelinerental@gmail.com" >
                  Contact
                </a>
              </span>
            </li> */}
            <li>
              <span className="block py-2 px-3 text-primary rounded md:bg-transparent md:p-0 hover:text-primary cursor-pointer">
                <a href="tel:1300850275" >
                1300 850 275
                </a>
              </span>
              {/* <a href="tel:1300850275" className="block text-bold py-2 px-3 text-primary rounded md:bg-transparent md:text-primary md:p-0 cursor-pointer">
                1300 850 275
              </a> */}
            </li>
            <li>
              <span className="block py-2 px-3 text-gray-900 rounded md:bg-transparent md:text-gray-900 md:p-0 hover:text-primary cursor-pointer" onClick={viewBookingEvent}>
                  View my booking
              </span>
            </li>
          </ul>
        </div>
      </div>

      <ViewBooking viewBookingToggle={viewBookingToggle} setViewBookingToggle={setViewBookingToggle}/>
    </nav>
  );
}

export default Nav;